import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '@/store'

export const useChangeIl8n = () => {
  const { language } = useAppSelector((state) => state.global)

  const { i18n } = useTranslation()
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
  }

  useEffect(() => {
    changeLanguage(language)
  }, [language])

  return {
    changeLanguage,
  }
}
